export default __webpack_public_path__ + "c6d953627273fdd17344ad6db627ba97.png";